module.exports = __webpack_public_path__ + "static/media/edit.7a14112e.svg";